import React, {forwardRef} from "react";
import useRequestData from "../../../hooks/useRequestData";
import {getUserList} from "../../../api/user/UserAccountService";
import UserAccountListType from "./subPages/UserAccountListType";
import "./userAccountManagePanel.css";

const UserAccountListDataBridge = forwardRef(function UserAccountListDataBridge(
    {listType, viewMode, onViewModeChange},
    ref,
) {
    const entity = listType ? "user_list" : "disabled_user_list";
    const {newData, pageInfo, dataHook} = useRequestData(
        (conditions, pageable) => getUserList({...conditions, disable: !listType}, pageable),
        {},
        entity,
    );

    return (
        <UserAccountListType
            ref={ref}
            data={newData?.content ?? []}
            dataHook={dataHook}
            pageInfo={pageInfo}
            listType={listType}
            viewMode={viewMode}
            onViewModeChange={onViewModeChange}
        />
    );
});

const UserAccountManagePanel = forwardRef(function UserAccountManagePanel(
    {listType, viewMode = "list", onViewModeChange},
    ref,
) {
    return (
        <UserAccountListDataBridge
            ref={ref}
            key={listType ? "active" : "inactive"}
            listType={listType}
            viewMode={viewMode}
            onViewModeChange={onViewModeChange}
        />
    );
});

export default UserAccountManagePanel;
